export default 'https://tme.understood.org/assets/eye.3cbe4a5c.glb'